import Toggle from 'components/Toggle'
import React from 'react'
import {BsCaretDownFill, BsCaretRightFill} from "react-icons/bs";
import {renderIf} from "../../views/Shared";

export const ToggleCollapseView = ({
    defaultValue = true,
    visibleToggle = true,
    title,
    children,
    style,
    size = 13,
}) => (
  <Toggle defaultValue={defaultValue}>
    {(isToggle, toggle) => (
      <>
        <div
          onClick={!!visibleToggle ? toggle : () => null}
          style={style}
          className="flex items-center justify-between gap-2 border-b cursor-pointer">
          <div className="flex-1 truncate font-medium text-sm text-color-300 uppercase">
            {title}
          </div>
          {
            renderIf(
              visibleToggle,
              isToggle ? (
                <BsCaretDownFill
                  size={size}
                  onClick={toggle}
                  className="text-xs text-color-400 hover:text-primary"
                />
              ) : (
                <BsCaretRightFill
                  size={size}
                  onClick={toggle}
                  className="text-xs text-color-400 hover:text-primary"
                />
              )
            )
          }
        </div>
        {isToggle && children}
      </>
    )}
  </Toggle>
)
